import React from 'react'
import coming from '../Assets/coming.avif'

const ComingSoon = () => {
  return (
    <div>
      <img src={coming}/>
    </div>
  )
}

export default ComingSoon
